import { configureStore } from '@reduxjs/toolkit';
import userSlice from './User/slice';
import { useDispatch } from 'react-redux';
import authSlice from './Auth/slice';
import orderSlice from './Order/slice';
import letterSlice from './Letter/slice';
import driverSlice from './Driver/slice';
import bidSlice from './Bid/slice';
import loadSlice from './Load/slice';
import locationSlice from './Location/slice';
import weatherSlice from './Weather/slice';
import chatSlice from './Chat/slice';

const store = configureStore({
  reducer: {
    user: userSlice.reducer,
    auth: authSlice.reducer,
    order: orderSlice.reducer,
    letter: letterSlice.reducer,
    driver: driverSlice.reducer,
    bid: bidSlice.reducer,
    load: loadSlice.reducer,
    location: locationSlice.reducer,
    weather: weatherSlice.reducer,
    chat: chatSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;
